import WelcomeBox from './WelcomeBox'

export default WelcomeBox
